import { __extends } from "tslib";
import { Icon } from '@wix/answers-ui-libby';
import * as React from 'react';
import { anchorIcon } from './anchor-icon';
import { componentViewerTranslate } from '../translations';
import { classNames } from '@wix/answers-lib';
import { calcDirection } from '../../utils/calc-direction';
var AnchorNavigation = /** @class */ (function (_super) {
    __extends(AnchorNavigation, _super);
    function AnchorNavigation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedAnchorId: ''
        };
        return _this;
    }
    AnchorNavigation.prototype.componentDidMount = function () {
        var _this = this;
        var cb = function (anchorId) {
            _this.setState({ selectedAnchorId: anchorId });
        };
        this.props.onAnchorIdChange(cb);
    };
    AnchorNavigation.prototype.render = function () {
        var _this = this;
        var props = this.props;
        // tslint:disable-next-line:max-line-length
        var anchors = (props.components || []).filter(function (c) { return c.type === 'heading' && !!c.value.anchorId; });
        var title = componentViewerTranslate(props.locale)("anchor-navigation.title");
        var anchorsComp = anchors.map(function (anchor, idx) {
            var anchorInView = _this.state.selectedAnchorId === anchor.value.anchorId;
            var anchorClass = anchorInView ? 'anchor-in-view' : '';
            var anchorLevel = anchor.value.level;
            var currentUrlWithoutAnchor = window.location.href.replace(/#.*$/, '');
            return (React.createElement("li", { className: "anchor indent-" + anchorLevel, key: idx },
                anchorInView ? React.createElement(Icon, { icon: anchorIcon }) : null,
                React.createElement("a", { className: anchorClass, href: currentUrlWithoutAnchor + "#" + anchor.value.anchorId }, anchor.value.text)));
        });
        var direction = calcDirection(props.locale);
        return (React.createElement("div", { className: classNames('anchor-navigation', direction) },
            React.createElement("div", { className: 'anchor-navigation-title' }, title),
            React.createElement("ul", { className: 'anchor-list' }, anchorsComp)));
    };
    return AnchorNavigation;
}(React.Component));
export { AnchorNavigation };
//# sourceMappingURL=anchor-navigation.comp.js.map